import React, {Component} from 'react';
import {connect} from 'react-redux';
import LoadingOverlay from 'react-loading-overlay-ts';

import {StoreState} from '~/frontend/src/store';

type Props = {
    // the data (form) dataContext
    forComponent : string | string[];
    children : React.ReactNode;
    isLoading? : boolean;
    className? : string;
    style? : React.CSSProperties
};

class LoadingMaskPanel extends Component<Props> {
    render() {
        const {
                  children,
                  isLoading,
                  className,
                  style
              } = this.props;

        return (
            <LoadingOverlay
                active={isLoading}
                spinner={<div
                    className="yn-fsz-loading-mask-spinner"
                />}
                className={`yn-loading-mask ${className ?? ''}`}
                styles={{
                    wrapper: ( base ) => {
                        return Object.assign( {}, base, style )
                    }
                }}
            >
                {children}
            </LoadingOverlay>
        );
    }
}

// redux stuff
function mapStateToProps( state : StoreState, ownProps : Props ) {
    const checkComponents = [].concat( ownProps.forComponent as any );

    return {
        isLoading: checkComponents.some( comp => !!state.xhr[ comp ] )
    };
}

export default connect( mapStateToProps )( LoadingMaskPanel );

